export default __webpack_public_path__ + "56ab226834915db3c121964d91926ae9.wav";